import React, { useState, useEffect, useMemo } from "react";
import { Banknote, Plus, Trash2 } from "lucide-react";

const CotizacionModal = ({
  solicitudId,
  cotizacion,
  onClose,
  onCotizacionCreated,
}) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!cotizacion || !cotizacion.items) {
      setItems([{ amount: 0, description: "" }]);
      return;
    }

    setItems(
      cotizacion.items.map((c) => ({
        amount: c.amount || "",
        description: c.description || "",
      }))
    );
  }, [cotizacion]);

  const addItem = () => {
    setItems([...items, { amount: "", description: "" }]);
  };

  const removeItem = (index) => {
    const updated = items.filter((_, i) => i !== index);
    setItems(updated.length ? updated : [{ amount: "", description: "" }]);
  };

  const updateItem = (index, field, value) => {
    const updated = [...items];
    updated[index][field] = value;
    setItems(updated);
  };

  const total = useMemo(() => {
    return items.reduce(
      (acc, item) => acc + (Number(item.amount) || 0),
      0
    );
  }, [items]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem("token");

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/quotations`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            application_id: solicitudId,
            items: items.map((i) => ({
              amount: parseFloat(i.amount),
              description: i.description,
            })),
            total_amount: total,
          }),
        }
      );

      if (response.ok) {
        onCotizacionCreated();
      } else {
        const error = await response.json();
        console.error(error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg max-w-2xl w-full mx-4">
        <div className="p-6 border-b">
          <h3 className="text-xl font-bold flex items-center">
            <Banknote className="mr-2" />
            Editar Cotización
          </h3>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          {items.map((item, index) => (
            <div key={index} className="flex gap-3 items-start">
              <input
                type="text"
                value={item.description}
                onChange={(e) =>
                  updateItem(index, "description", e.target.value)
                }
                className="flex-1 p-2 border rounded"
                placeholder="Descripción"
              />

              <input
                type="number"
                value={item.amount}
                onChange={(e) =>
                  updateItem(index, "amount", e.target.value)
                }
                className="w-32 p-2 border rounded"
                placeholder="Monto"
                min="0"
                step="0.01"
                required
              />

              <button
                type="button"
                onClick={() => removeItem(index)}
                className="text-red-500"
              >
                <Trash2 size={18} />
              </button>
            </div>
          ))}

          <button
            type="button"
            onClick={addItem}
            className="flex items-center text-blue-600"
          >
            <Plus size={16} className="mr-1" />
            Agregar partida
          </button>

          <div className="text-right font-bold text-lg">
            Total: ${total.toFixed(2)} MXN
          </div>

          <div className="flex space-x-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 bg-gray-300 py-2 rounded"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={loading}
              className="flex-1 bg-blue-600 text-white py-2 rounded"
            >
              {loading ? "Guardando..." : "Guardar Cotización"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CotizacionModal;